import Header from "../Components/CBSFormSections/Header";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div role="alert">
      <div id="cbs-forms" style={{ padding: "20px 0px 25px" }}>
        <div className="common-input-field">
          <div className="card custom-card">
            <Header />
            <div className="page-error-content">
              <div className="error-code mb-4 animated zoomInDown">
                Please try again. We apologize for any inconvenience.
              </div>
              {/* <h4 className="text-center fw-regular title bounceIn animated-delay-10 animated">
                
              </h4> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;

// import React, { Component } from "react";

// class ErrorBoundary extends Component {
//   constructor(props) {
//     super(props);
//     this.state = { hasError: false };
//   }

//   componentDidCatch(error, info) {
//     this.setState({ hasError: true });
//   }

//   render() {
//     {
//       console.log(this.state);
//     }
//     const { errorMessage = "Something went wrong." } = this.props;
//     if (this.state.hasError) {
//       return (
//         <div id="cbs-forms" style={{ padding: "20px 0px 25px" }}>
//           <div className="common-input-field">
//             <Header />
//             <div className="card custom-card">
//               <div className="page-error-content">
//                 <div className="error-code mb-4 animated zoomInDown">500</div>
//                 <h2 className="text-center fw-regular title bounceIn animated-delay-10 animated">
//                   {errorMessage}
//                 </h2>
//               </div>
//             </div>
//           </div>
//         </div>
//       );
//     }
//     return this.props.children;
//   }
// }

// export default ErrorBoundary;
